import React, { useContext, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
} from "@chakra-ui/react";
import ChatContext from "./context";

const Name = () => {
  const [isOpen, setIsOpen] = useState(true);
  const handleClose = () => setIsOpen(false);
  const [name, setName] = useState("");
  const { store, updateData } = useContext(ChatContext);

  const addName = (event) => {
    if ((event.key === "Enter") & (name !== "")) {
      const newData = { ...store };
      newData.name = name;
      newData.messages = [{
        messageId: 1, 
        senderName: "Zucky",
        content: `Hello ${name}, how may I help you today?`,
        timestamp: new Date().toISOString(),
      }]
      updateData(newData);
      handleClose();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size={"md"} closeOnOverlayClick={false} isCentered>
      <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(10px)" />
      <ModalContent 
        className="rounded-[24px] overflow-hidden"
        style={{
          background: 'linear-gradient(to bottom, #D5D5D5, #E1DFFF)',
          border: 'none',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
        }}
      >
        <ModalBody className="p-8 md:p-12">
          <div className="flex flex-col items-center">
            <h2 className="text-xl md:text-2xl font-medium mb-3 text-[#3429B3] text-center">
              Welcome to Zucky AI
            </h2>
            <p className="text-sm md:text-base text-gray-600 mb-8 text-center max-w-sm">
              Please enter your name to get started
            </p>
            <input
              type="text"
              onChange={(e) => setName(e.target.value)}
              value={name}
              placeholder="Your Name"
              className="w-full px-5 py-3.5 text-base md:text-lg bg-white bg-opacity-90 border-2 border-[#4940A9] rounded-[12px] focus:outline-none focus:ring-2 focus:ring-[#AE2DC7] focus:border-transparent transition-all shadow-sm"
              onKeyPress={addName}
              autoFocus
            />
            <p className="text-xs text-gray-500 mt-4 text-center">
              Press Enter to continue
            </p>
          </div>
        </ModalBody>
        <ModalFooter className="justify-center pb-8">
          <div className="w-20 h-1 bg-gradient-to-r from-[#4940A9] to-[#AE2DC7] rounded-full"></div>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default Name;
